"use client";

import { useState } from "react";
import { 
  Sheet, 
  SheetContent, 
  SheetHeader, 
  SheetTitle, 
  SheetTrigger 
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import Link from "next/link";
import Image from "next/image";

export function MobileNav() {
  const [open, setOpen] = useState(false);

  const navLinks = [
    { href: "/", label: "Home" },
    { href: "/projects", label: "Solutions" },
    { href: "/academy", label: "Academy" },
    { href: "/about", label: "About Us" },
    { href: "/contact", label: "Contact" },
  ];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="outline" size="icon" className="h-10 w-10">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle Menu</span>
        </Button>
      </SheetTrigger>

      <SheetContent side="left" className="pr-0 bg-background border-r border-white/10">
        {/* این هدر برای رفع ارور دسترسی‌پذیری اضافه شده و در ظاهر دیده نمی‌شود */}
        <SheetHeader className="sr-only">
          <SheetTitle>Mobile Navigation Menu</SheetTitle>
        </SheetHeader>

        <Link
          href="/"
          className="mr-6 flex items-center pl-6"
          onClick={() => setOpen(false)}
        >
          <Image
            src="/logo.png"
            alt="BornAI Logo"
            width={120}
            height={40}
            className="h-8 w-auto"
            priority
          />
        </Link>
        <div className="mt-8 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="flex items-center text-lg font-medium text-muted-foreground transition-colors hover:text-primary pl-6"
            >
              {link.label}
            </Link>
          ))}
        </div>
        <div className="absolute bottom-8 left-6 right-6">
            <Button asChild className="w-full bg-primary text-white">
                <Link href="/contact" onClick={() => setOpen(false)}>
                    Get Consultation
                </Link>
            </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}